import "./LoginSlides.css";

const YEAR = new Date().getFullYear();
const Footer = () => (
  <div className="ls-footer">
    <span className="ls-footer-icon">☰</span>
    © All rights reserved. {YEAR} Pallet
  </div>
);

/* ──────────────────────────────────────────────────────────
   SLIDE 4  –  Wine & Liquor
   ────────────────────────────────────────────────────────── */
export function SlideWine() {
  return (
    <div className="ls-slide">
      <span className="ls-item xl fa" style={{ top: "5%",   left: "4%" }}>🍷</span>
      <span className="ls-item md fb" style={{ top: "14%",  left: "22%" }}>🥃</span>
      <span className="ls-item lg fc" style={{ top: "5%",   right: "12%" }}>🍾</span>
      <span className="ls-item md fd" style={{ top: "4%",   right: "4%" }}>🥂</span>
      <span className="ls-item lg fe" style={{ top: "28%",  left: "4%" }}>🍸</span>
      <span className="ls-item md ff" style={{ bottom: "26%", right: "4%" }}>🍹</span>
      <span className="ls-item xl fb" style={{ bottom: "7%", left: "3%" }}>🫗</span>
      <span className="ls-item lg fa" style={{ bottom: "8%", right: "5%" }}>🍶</span>
      <div className="ls-text">
        <h2 className="ls-headline">Raise the bar<br />for retail.</h2>
        <p className="ls-sub">Intelligent inventory and effortless checkout for every bottle.</p>
        <p className="ls-tag">For Wine &amp; Liquor Stores</p>
      </div>
      <Footer />
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 5  –  Bars & Clubs
   ────────────────────────────────────────────────────────── */
export function SlideBar() {
  return (
    <div className="ls-slide">
      <span className="ls-item xl fa" style={{ top: "5%",   left: "4%" }}>🍺</span>
      <span className="ls-item sm fc" style={{ top: "14%",  left: "21%" }}>🎵</span>
      <span className="ls-item lg fb" style={{ top: "6%",   right: "13%" }}>🍻</span>
      <span className="ls-item md fd" style={{ top: "4%",   right: "4%" }}>🎶</span>
      <span className="ls-item lg fe" style={{ top: "28%",  right: "4%" }}>🎤</span>
      <span className="ls-item md ff" style={{ bottom: "27%", left: "4%" }}>🥂</span>
      <span className="ls-item xl fc" style={{ bottom: "7%", left: "3%" }}>🍸</span>
      <span className="ls-item sm fa" style={{ bottom: "19%", left: "18%" }}>🎸</span>
      <span className="ls-item lg fb" style={{ bottom: "8%", right: "5%" }}>🍹</span>
      <div className="ls-text">
        <h2 className="ls-headline">Built for the<br />busiest nights.</h2>
        <p className="ls-sub">Fast tabs, smart inventory, and service without delays.</p>
        <p className="ls-tag">For Bars &amp; Clubs</p>
      </div>
      <Footer />
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 6  –  Breweries
   ────────────────────────────────────────────────────────── */
export function SlideBrewery() {
  return (
    <div className="ls-slide">
      <span className="ls-item xl fa" style={{ top: "5%",   left: "4%" }}>🍺</span>
      <span className="ls-item md fb" style={{ top: "14%",  left: "21%" }}>🌾</span>
      <span className="ls-item lg fc" style={{ top: "5%",   right: "12%" }}>🍻</span>
      <span className="ls-item md fd" style={{ top: "4%",   right: "4%" }}>🌿</span>
      <span className="ls-item lg fe" style={{ top: "28%",  left: "4%" }}>🛢️</span>
      <span className="ls-item md ff" style={{ bottom: "27%", right: "4%" }}>🫙</span>
      <span className="ls-item xl fb" style={{ bottom: "7%", left: "3%" }}>🏭</span>
      <span className="ls-item sm fa" style={{ bottom: "19%", left: "19%" }}>🌊</span>
      <span className="ls-item lg fc" style={{ bottom: "8%", right: "5%" }}>🥂</span>
      <div className="ls-text">
        <h2 className="ls-headline">Craft meets<br />technology.</h2>
        <p className="ls-sub">From keg to checkout, every pour stays accounted for.</p>
        <p className="ls-tag">For Breweries</p>
      </div>
      <Footer />
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 7  –  Fashion
   ────────────────────────────────────────────────────────── */
export function SlideFashion() {
  return (
    <div className="ls-slide">
      <span className="ls-item xl fa" style={{ top: "5%",   left: "4%" }}>👗</span>
      <span className="ls-item sm fd" style={{ top: "14%",  left: "22%" }}>🕶️</span>
      <span className="ls-item lg fb" style={{ top: "5%",   right: "12%" }}>👠</span>
      <span className="ls-item md fc" style={{ top: "4%",   right: "4%" }}>👜</span>
      <span className="ls-item lg fe" style={{ top: "28%",  right: "4%" }}>🧣</span>
      <span className="ls-item md ff" style={{ bottom: "27%", left: "4%" }}>👒</span>
      <span className="ls-item xl fc" style={{ bottom: "7%", left: "3%" }}>💍</span>
      <span className="ls-item sm fa" style={{ bottom: "19%", left: "18%" }}>✨</span>
      <span className="ls-item lg fb" style={{ bottom: "8%", right: "5%" }}>🛍️</span>
      <div className="ls-text">
        <h2 className="ls-headline">Where great retail never<br />goes out of style.</h2>
        <p className="ls-sub">Modern commerce for modern fashion brands.</p>
        <p className="ls-tag">For Fashion Retail</p>
      </div>
      <Footer />
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 8  –  Apparel
   ────────────────────────────────────────────────────────── */
export function SlideApparel() {
  return (
    <div className="ls-slide">
      <span className="ls-item xl fb" style={{ top: "5%",   left: "4%" }}>👕</span>
      <span className="ls-item md fd" style={{ top: "13%",  left: "21%" }}>🧢</span>
      <span className="ls-item lg fa" style={{ top: "5%",   right: "12%" }}>👖</span>
      <span className="ls-item md fc" style={{ top: "4%",   right: "4%" }}>🎽</span>
      <span className="ls-item lg fe" style={{ top: "28%",  left: "4%" }}>🧥</span>
      <span className="ls-item md ff" style={{ bottom: "27%", right: "4%" }}>👔</span>
      <span className="ls-item xl fa" style={{ bottom: "7%", left: "3%" }}>🧤</span>
      <span className="ls-item sm fb" style={{ bottom: "19%", left: "18%" }}>🧦</span>
      <span className="ls-item lg fc" style={{ bottom: "8%", right: "5%" }}>🛍️</span>
      <div className="ls-text">
        <h2 className="ls-headline">Every collection,<br />perfectly connected.</h2>
        <p className="ls-sub">Manage styles, sizes, and sales in real time.</p>
        <p className="ls-tag">For Apparel Brands</p>
      </div>
      <Footer />
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 9  –  Cosmetics
   ────────────────────────────────────────────────────────── */
export function SlideCosmetics() {
  return (
    <div className="ls-slide">
      <span className="ls-item xl fa" style={{ top: "5%",   left: "4%" }}>💄</span>
      <span className="ls-item sm fc" style={{ top: "13%",  left: "22%" }}>✨</span>
      <span className="ls-item lg fb" style={{ top: "5%",   right: "12%" }}>🧴</span>
      <span className="ls-item md fd" style={{ top: "4%",   right: "4%" }}>💋</span>
      <span className="ls-item lg fe" style={{ top: "28%",  right: "4%" }}>🪞</span>
      <span className="ls-item md ff" style={{ bottom: "27%", left: "4%" }}>💅</span>
      <span className="ls-item xl fb" style={{ bottom: "7%", left: "3%" }}>🧖</span>
      <span className="ls-item sm fa" style={{ bottom: "19%", left: "18%" }}>💆</span>
      <span className="ls-item lg fc" style={{ bottom: "8%", right: "5%" }}>🌸</span>
      <div className="ls-text">
        <h2 className="ls-headline">Beauty,<br />beautifully managed.</h2>
        <p className="ls-sub">Smart inventory and seamless checkout for every shade.</p>
        <p className="ls-tag">For Cosmetics &amp; Beauty</p>
      </div>
      <Footer />
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 10  –  Footwear
   ────────────────────────────────────────────────────────── */
export function SlideFootwear() {
  return (
    <div className="ls-slide">
      <span className="ls-item xl fa" style={{ top: "5%",   left: "4%" }}>👟</span>
      <span className="ls-item md fd" style={{ top: "13%",  left: "22%" }}>🧦</span>
      <span className="ls-item lg fb" style={{ top: "5%",   right: "12%" }}>👠</span>
      <span className="ls-item md fc" style={{ top: "4%",   right: "4%" }}>👞</span>
      <span className="ls-item lg fe" style={{ top: "28%",  left: "4%" }}>👢</span>
      <span className="ls-item md ff" style={{ bottom: "27%", right: "4%" }}>🥿</span>
      <span className="ls-item xl fc" style={{ bottom: "7%", left: "3%" }}>👣</span>
      <span className="ls-item sm fa" style={{ bottom: "19%", left: "18%" }}>🛍️</span>
      <span className="ls-item lg fb" style={{ bottom: "8%", right: "5%" }}>✨</span>
      <div className="ls-text">
        <h2 className="ls-headline">Step into<br />smarter retail.</h2>
        <p className="ls-sub">Inventory, billing, and customer experiences in one place.</p>
        <p className="ls-tag">For Footwear Retail</p>
      </div>
      <Footer />
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 11  –  Jewellery
   ────────────────────────────────────────────────────────── */
export function SlideJewellery() {
  return (
    <div className="ls-slide">
      <span className="ls-item xl fa" style={{ top: "5%",   left: "4%" }}>💍</span>
      <span className="ls-item sm fd" style={{ top: "13%",  left: "22%" }}>✨</span>
      <span className="ls-item lg fb" style={{ top: "5%",   right: "12%" }}>💎</span>
      <span className="ls-item md fc" style={{ top: "4%",   right: "4%" }}>👑</span>
      <span className="ls-item lg fe" style={{ top: "28%",  right: "4%" }}>📿</span>
      <span className="ls-item md ff" style={{ bottom: "27%", left: "4%" }}>🔮</span>
      <span className="ls-item xl fb" style={{ bottom: "7%", left: "3%" }}>💫</span>
      <span className="ls-item sm fa" style={{ bottom: "19%", left: "18%" }}>🌟</span>
      <span className="ls-item lg fc" style={{ bottom: "8%", right: "5%" }}>🏺</span>
      <div className="ls-text">
        <h2 className="ls-headline">Precision worthy<br />of every gem.</h2>
        <p className="ls-sub">Secure, intelligent retail built for luxury.</p>
        <p className="ls-tag">For Jewellery &amp; Luxury</p>
      </div>
      <Footer />
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 12  –  Bakery
   ────────────────────────────────────────────────────────── */
export function SlideBakery() {
  return (
    <div className="ls-slide">
      <span className="ls-item xl fa" style={{ top: "5%",   left: "4%" }}>🍞</span>
      <span className="ls-item md fb" style={{ top: "13%",  left: "21%" }}>🥐</span>
      <span className="ls-item lg fc" style={{ top: "5%",   right: "12%" }}>🎂</span>
      <span className="ls-item md fd" style={{ top: "4%",   right: "4%" }}>🧁</span>
      <span className="ls-item lg fe" style={{ top: "28%",  left: "4%" }}>🥖</span>
      <span className="ls-item md ff" style={{ bottom: "27%", right: "4%" }}>🍰</span>
      <span className="ls-item xl fb" style={{ bottom: "7%", left: "3%" }}>🫓</span>
      <span className="ls-item sm fa" style={{ bottom: "19%", left: "18%" }}>🍩</span>
      <span className="ls-item lg fc" style={{ bottom: "8%", right: "5%" }}>🍪</span>
      <div className="ls-text">
        <h2 className="ls-headline">Fresh products.<br />Smarter operations.</h2>
        <p className="ls-sub">Reduce waste, speed up service, and keep every shelf stocked.</p>
        <p className="ls-tag">For Bakeries</p>
      </div>
      <Footer />
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 3  –  Pharmacy
   ────────────────────────────────────────────────────────── */
export function SlidePharmacy() {
  return (
    <div className="ls-slide">
      {/* top-left: pill bottle */}
      <span className="ls-item xl fb" style={{ top: "5%",  left: "4%" }}>💊</span>
      <span className="ls-item sm fd" style={{ top: "14%", left: "20%" }}>🩺</span>

      {/* top-right: syringe + stethoscope */}
      <span className="ls-item lg fa" style={{ top: "6%",  right: "14%" }}>💉</span>
      <span className="ls-item md fc" style={{ top: "4%",  right: "5%" }}>🩻</span>

      {/* mid-left: microscope */}
      <span className="ls-item lg fe" style={{ top: "26%", left: "4%" }}>🔬</span>

      {/* mid-right: bandage */}
      <span className="ls-item md ff" style={{ bottom: "26%", right: "4%" }}>🩹</span>

      {/* bottom-left: medical bag */}
      <span className="ls-item xl fc" style={{ bottom: "7%", left: "3%" }}>🧪</span>
      <span className="ls-item sm fa" style={{ bottom: "18%", left: "18%" }}>🧬</span>

      {/* bottom-right: hospital */}
      <span className="ls-item lg fb" style={{ bottom: "8%", right: "5%" }}>🏥</span>

      {/* centre text */}
      <div className="ls-text">
        <h2 className="ls-headline">Curing checkout<br />headaches instantly.</h2>
        <p className="ls-sub">Fast dispensing, zero-glitch stock tracking, and total compliance—no prescription required.</p>
        <p className="ls-tag">For Pharmacies</p>
      </div>

      <div className="ls-footer">
        <span className="ls-footer-icon">☰</span>
        © All rights reserved. {new Date().getFullYear()} Pallet
      </div>
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 1  –  Serve Success  (Restaurant)
   ────────────────────────────────────────────────────────── */
export function SlideRestaurant() {
  return (
    <div className="ls-slide">
      {/* top-left cluster: burger + drink */}
      <span className="ls-item xl fa" style={{ top: "6%",  left: "5%" }}>🍔</span>
      <span className="ls-item sm fb" style={{ top: "12%", left: "20%" }}>🍟</span>
      <span className="ls-item md fc" style={{ top: "4%",  left: "28%" }}>🥤</span>

      {/* top-right: dessert bowl */}
      <span className="ls-item lg fd" style={{ top: "7%",  right: "8%" }}>🍨</span>

      {/* bottom-left: pizza slice */}
      <span className="ls-item xl fe" style={{ bottom: "9%", left: "4%" }}>🍕</span>

      {/* bottom-right: sizzling pan */}
      <span className="ls-item lg fa" style={{ bottom: "8%", right: "6%" }}>🍳</span>

      {/* bottom-center: noodle bowl */}
      <span className="ls-item xl fc" style={{ bottom: "4%", left: "50%", transform: "translateX(-50%)" }}>🍜</span>

      {/* centre text */}
      <div className="ls-text">
        <h2 className="ls-headline">Less kitchen chaos,<br />more 'Chef's Kiss.'</h2>
        <p className="ls-sub">Lynx handles the tickets, tables, and tech—you just cook up the magic.</p>
        <p className="ls-tag">For QSR & Fine Dine Restaurants</p>
      </div>

      <div className="ls-footer">
        <span className="ls-footer-icon">☰</span>
        © All rights reserved. {new Date().getFullYear()} Pallet
      </div>
    </div>
  );
}

/* ──────────────────────────────────────────────────────────
   SLIDE 2  –  Serve Fresh  (Supermarket)
   ────────────────────────────────────────────────────────── */
export function SlideMarket() {
  return (
    <div className="ls-slide">
      {/* top-left: grocery bag */}
      <span className="ls-item xl fb" style={{ top: "5%",  left: "4%" }}>🛍️</span>

      {/* top-right cluster: avocado + tomato */}
      <span className="ls-item lg fa" style={{ top: "6%",  right: "14%" }}>🥑</span>
      <span className="ls-item md fd" style={{ top: "4%",  right: "5%" }}>🍅</span>

      {/* mid-right: carrot */}
      <span className="ls-item lg fe" style={{ top: "42%", right: "5%" }}>🥕</span>

      {/* bottom-left: shopping cart with items */}
      <span className="ls-item xl fc" style={{ bottom: "7%", left: "3%" }}>🛒</span>
      <span className="ls-item sm ff" style={{ bottom: "18%", left: "18%" }}>🧃</span>
      <span className="ls-item md fa" style={{ bottom: "20%", left: "6%" }}>🍫</span>

      {/* bottom-right: apple */}
      <span className="ls-item lg fb" style={{ bottom: "8%", right: "5%" }}>🍎</span>

      {/* centre text */}
      <div className="ls-text">
        <h2 className="ls-headline">Retail intelligence<br />at every checkout.</h2>
        <p className="ls-sub">Smarter inventory, faster billing, and insights that help you sell more.</p>
        <p className="ls-tag">For Grocery, Supermarkets &amp; Hypermarkets</p>
      </div>

      <div className="ls-footer">
        <span className="ls-footer-icon">☰</span>
        © All rights reserved. {new Date().getFullYear()} Pallet
      </div>
    </div>
  );
}
